export function isJsonObject(str: string): boolean {
	try {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const parsed = JSON.parse(str);
		return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed);
	} catch {
		return false;
	}
}

export const isValidFolderName = (name: string): boolean =>
	!/[<>:"/\\|?*]/.test(name) && !/[ .]$/.test(name);
